import Text from 'components/Text/Text';
import './TableHeader.scss';

interface IProps {
  type?: 'primary' | 'secondary';
}

const TableHeader = ({type = 'primary'}: IProps) => {
  return (
    <thead
      data-testid="table-header"
      className={`table-header ${type === 'primary' ? 'table-header--primary' : 'table-header--secondary'}`}
    >
      <tr>
        <td className="table-header__drag">
          <Text data-testid="drag-text" tag="span">
            Reorder
          </Text>
        </td>
        <td className="table-header__name">
          <Text tag="span">Name</Text>
        </td>
        <td className="table-header__edit">
          <Text tag="span">Edit</Text>
        </td>
        <td className="table-header__select">
          <Text tag="span">On Tap</Text>
        </td>
      </tr>
    </thead>
  );
};

export default TableHeader;
